<href class="block"
      [link]="colourData.colourLink">
    <div class="flex flex-middle bg-col-4">

        <div class="colour-swatch"
             [bgContrast]="colourData.colour"
             [tolerance]="200"
             [style.background-color]="colourData.colour"></div>

        @if (colourData.colourName) {
        <div class="m-l-1 m-r-2 col-1 left colour-name"
             [innerHTML]="colourData.colourName.split(' ').join('<br>')"></div>
        }
    </div>
</href>